var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSaveTeal(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.75,
    y: 2.75,
    width: 22.5,
    height: 22.5,
    rx: 10.75,
    fill: "white",
    stroke: "#00A7A4",
    strokeWidth: 1.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_746_20429)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.168 18.6582C11.4375 18.9277 11.7969 19.0625 12.2012 19.0625C12.5605 19.0625 12.9199 18.9277 13.1895 18.6582L20.377 11.4707C20.6465 11.2012 20.8262 10.8418 20.8262 10.4375C20.8262 9.62891 20.1523 9 19.3887 9C18.9844 9 18.625 9.17969 18.3555 9.44922L12.2012 15.6035L9.5957 13.043C9.32617 12.7734 8.9668 12.5938 8.60742 12.5938C7.79883 12.5938 7.16992 13.2227 7.16992 14.0312C7.16992 14.4355 7.30469 14.7949 7.57422 15.0645L11.168 18.6582Z",
    fill: "#00A7A4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_746_20429"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSaveTeal);
export default __webpack_public_path__ + "static/media/Icon_Save_Teal.74f1f753d8b88706b88e1129f5579c07.svg";
export { ForwardRef as ReactComponent };